var _rect, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 63.25,
    height: 63.25,
    rx: 31.625,
    stroke: "#101828",
    strokeWidth: 0.75
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 19.9993H26.4C24.1598 19.9993 23.0397 19.9993 22.184 20.4353C21.4314 20.8188 20.8195 21.4307 20.436 22.1834C20 23.039 20 24.1591 20 26.3993V37.5994C20 39.8396 20 40.9597 20.436 41.8153C20.8195 42.568 21.4314 43.1799 22.184 43.5634C23.0397 43.9994 24.1598 43.9994 26.4 43.9994H38.6667C39.9066 43.9994 40.5266 43.9994 41.0353 43.8631C42.4156 43.4932 43.4938 42.415 43.8637 41.0346C44 40.526 44 39.906 44 38.666M41.3333 26.666V18.666M37.3333 22.666H45.3333M30 27.3327C30 28.8054 28.8061 29.9994 27.3333 29.9994C25.8606 29.9994 24.6667 28.8054 24.6667 27.3327C24.6667 25.8599 25.8606 24.666 27.3333 24.666C28.8061 24.666 30 25.8599 30 27.3327ZM35.9867 31.8902L24.7082 42.1434C24.0738 42.7201 23.7566 43.0085 23.7286 43.2583C23.7043 43.4748 23.7873 43.6895 23.9509 43.8334C24.1397 43.9994 24.5684 43.9994 25.4257 43.9994H37.9413C39.8602 43.9994 40.8196 43.9994 41.5732 43.677C42.5193 43.2723 43.2729 42.5186 43.6776 41.5726C44 40.819 44 39.8595 44 37.9407C44 37.295 44 36.9722 43.9294 36.6716C43.8407 36.2937 43.6706 35.9398 43.431 35.6345C43.2403 35.3916 42.9883 35.19 42.4841 34.7866L38.7544 31.8029C38.2499 31.3992 37.9976 31.1974 37.7197 31.1262C37.4748 31.0634 37.2172 31.0715 36.9767 31.1496C36.7039 31.2382 36.4648 31.4555 35.9867 31.8902Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPicture);
export default __webpack_public_path__ + "static/media/avatar-picture.76de130ea19420961c6329c818b60342.svg";
export { ForwardRef as ReactComponent };